import React, { useState } from 'react'
import { Form } from 'react-aria-components'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/Button'
import {
  Dialog,
  DialogTrigger,
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@/components/Modal'
import { TextField } from '@/components/TextField'

type Props = {
  resetUserPassword: (password: string) => void
}

export default function ResetPasswordDialog({ resetUserPassword }: Props) {
  const [password, setPassword] = useState('')
  const { t } = useTranslation()

  return (
    <DialogTrigger>
      <Button>{t('users.resetPassword')}</Button>
      <Modal style={{ width: 400, display: 'flex', flexDirection: 'column' }}>
        <Dialog style={{ flex: 1 }}>
          {({ close }) => (
            <>
              <ModalHeader onClose={close}>{t('users.resetPassword')}</ModalHeader>

              <ModalContent style={{ flex: 1 }}>
                <Form>
                  <TextField
                    autoFocus
                    onChange={(value) => {
                      setPassword(value)
                    }}
                    label={t('users.newPassword')}
                    name="password"
                    type="password"
                    isRequired></TextField>
                </Form>
              </ModalContent>

              <ModalFooter onClose={close}>
                <Button
                  variant="primary"
                  onPress={() => {
                    close()
                    resetUserPassword(password)
                  }}>
                  {t('users.resetPassword')}
                </Button>
              </ModalFooter>
            </>
          )}
        </Dialog>
      </Modal>
    </DialogTrigger>
  )
}
